import { useEffect } from "react";
import { saveMessageLogs as saveMessageLogsFetch } from "utils/consoleLogging";
import { useCallback } from "react";
import { updateLogList, useUiValue } from "stores/uiContext";

const useConsoleLogging = () => {
  const [{ logList }, dispatch] = useUiValue();

  useEffect(() => {
    if (
      window.performance.navigation.type ===
      PerformanceNavigation.TYPE_BACK_FORWARD
    ) {
      window.location.reload();
    }
    dispatch(updateLogList(logList));
  }, []);

  const addNewLog = useCallback(
    (log) => {
      const newLogList = [...logList, log];
      dispatch(updateLogList(newLogList));
    },
    [logList]
  );

  const saveLogs = useCallback(
    (list, formData) => {
      saveMessageLogsFetch(list, formData).then((res) => {
        dispatch(updateLogList([]));
      });
    },
    [logList]
  );

  return { logList, saveLogs, addNewLog };
};
export default useConsoleLogging;
